import { BaseObjectEntity } from '@/types';
import { generatePath } from 'react-router';

export const ROOTS_BOOKINGS_MANAGEMENT = '/bookings-management';

export const PATH_BOOKINGS_MANAGEMENT: BaseObjectEntity = {
  root: ROOTS_BOOKINGS_MANAGEMENT,
  bookingsRoot: 'bookings',
  list: 'bookings/list',
  new: 'bookings/new',
  edit: 'bookings/edit/:bookingId',
  view: 'bookings/view/:bookingId/:bookingTabSid',
  viewWithSessionFilter: 'bookings/view/:bookingId/:bookingTabSid/:sessionFilter',
  sessionsRoot: 'sessions',
  sessionsList: 'sessions/list',
};

const joinPath = (root: string, subPath: string) => {
  const cleanRoot = root.replace(/\/+$/, '');
  const cleanSub = subPath.replace(/^\/+/, '');
  return `${cleanRoot}/${cleanSub}`;
};

export function bookingsManagementPath(
  pathKey: string,
  params?: BaseObjectEntity
) {
  let finalPathKey = pathKey;

  if (pathKey === 'view' && params?.bookingTabSid === 'booking-sessions') {
    finalPathKey = 'viewWithSessionFilter';
  }

  return generatePath(
    joinPath(ROOTS_BOOKINGS_MANAGEMENT, PATH_BOOKINGS_MANAGEMENT[finalPathKey]),
    params
  );
}
